__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "somecrm";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@mantine/core", "7.17.8", () => (Promise.all([__webpack_require__.e(723), __webpack_require__.e(482), __webpack_require__.e(525), __webpack_require__.e(560), __webpack_require__.e(31)]).then(() => (() => (__webpack_require__(32482))))));
			register("@mantine/core", "7.17.8", () => (Promise.all([__webpack_require__.e(510), __webpack_require__.e(183), __webpack_require__.e(583), __webpack_require__.e(261)]).then(() => (() => (__webpack_require__(79510))))));
			register("@mantine/dates", "7.17.8", () => (Promise.all([__webpack_require__.e(353), __webpack_require__.e(560), __webpack_require__.e(563), __webpack_require__.e(567), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(41353))))));
			register("@mantine/hooks", "7.17.8", () => (__webpack_require__.e(119).then(() => (() => (__webpack_require__(60119))))));
			register("@mantine/hooks", "7.17.8", () => (__webpack_require__.e(826).then(() => (() => (__webpack_require__(41445))))));
			register("@mantine/notifications", "7.17.8", () => (Promise.all([__webpack_require__.e(203), __webpack_require__.e(760), __webpack_require__.e(525), __webpack_require__.e(560), __webpack_require__.e(563), __webpack_require__.e(162)]).then(() => (() => (__webpack_require__(19203))))));
			register("dayjs", "1.11.23", () => (__webpack_require__.e(413).then(() => (() => (__webpack_require__(49413))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(81312))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(47608))), 1);
			register("react-intl", "7.1.14", () => (Promise.all([__webpack_require__.e(741), __webpack_require__.e(883)]).then(() => (() => (__webpack_require__(69741))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(636), __webpack_require__.e(525)]).then(() => (() => (__webpack_require__(5636))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(528), __webpack_require__.e(183)]).then(() => (() => (__webpack_require__(61528))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(26111))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(76777))), 1);
			initExternal(43375);
			initExternal(77251);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};